export default __webpack_public_path__ + "static/media/stern.b2e51eb7.png";